// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Fkarg","website":"styles_website__IHDs2","link":"styles_link__BteHn"};